import baseTheme from "./baseTheme";
const theme = ({ fontFamily } = {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"'
})=>baseTheme({
        fontFamily,
        themeOverrides: {
            headerNavBg: '#000',
            headerNavColor: '#000',
            brandColor: '#000',
            primaryColor: '#fff'
        }
    });
export default theme;
